import { constants } from "../../../constants";

export default class OutOfMoney {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    SPINOMENAL_handler(data) {
        if (data.data && data.data.code && data.data.code == 6011) {
            this.gb.emitters.emit.web.outOfMoney();
        } else {
            this.gb.emitters.emit.web.error(data);
        }
    }

    _default() {
        this.gb.emitters.emit.web.outOfMoney();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PRAGMATIC_PLAY:
                event["balanceTooLow"] = this._default;
                break;
            case constants.F1X2:
                event["no-funds"] = this._default;
                break;
            case constants.SLINGO:
                event["insufficientFundsError"] = this._default;
                break;
            case constants.AMATIC:
                event["lowBalance"] = this._default;
                break;
            case constants.EDICT:
                event["balanceTooLow"] = this._default;
                break;
            // case constants.GSBINGO:
            case constants.GSPOKER:
                event["insufficientFunds"] = this._default;
                break;
            case constants.RRG:
                event["BALANCE_TOO_LOW"] = this._default;
                break;
            case constants.BGS:
                event["insufficientFunds"] = this._default;
                break;
            case constants.RGU:
                event["insufficientFunds"] = this._default;
                break;
            case constants.RAW:
                event["insufficientFunds"] = this._default;
                break;
            case constants.HB:
                event["insufficientFunds"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["OUT_OF_MONEY"] = this._default;
                break;
            case constants.YGG:
                event["spin/lowBalance"] = this._default;
                break;
            case constants.SPIN:
                event["out_of_credits"] = this._default;
                break;
            case constants.PLS:
                event["gameCashLow"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["betError"] = this.SPINOMENAL_handler;
                break;
            case constants.ENDOR:
                event["possibleOutOfMoney"] = this._default;
                break;
            default:
                event["errorOutOfMoney"] = this._default;
        }

        return event;
    }
}
